import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import AboutMe from "@/pages/AboutMe";

function App() {
  useEffect(() => {
    // Dismiss preloader once React has finished initial mount
    const timer = setTimeout(() => {
      if (typeof window.dismissPreloader === "function") {
        window.dismissPreloader();
      }
    }, 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <LanguageProvider>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/about" element={<AboutMe />} />
          <Route path="/aboutme" element={<AboutMe />} />
          <Route path="/rreth-nesh" element={<AboutMe />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;